import jsCookies from 'js-cookie';

import type { CookieOptions } from './types';

const numberIsInteger = (value: unknown): value is number => {
  if (Number.isInteger) {
    return Number.isInteger(value);
  }

  return (
    // eslint-disable-next-line no-restricted-globals
    typeof value === 'number' && isFinite(value) && Math.floor(value) === value
  );
};

/**
 * Stores full cookie in the document
 * @param name Cookie name
 * @param value Cookie value
 * @param expires Number of days for cookie to be valid for.
 *   If undefined or null then a session cookie will be created.
 * @param options object for optional parameters
 */
export function storeCookie(
  name: string,
  value: string,
  expires: number | null | undefined,
  { path = '/', secure = true }: CookieOptions = {},
): void {
  if (expires == null) {
    jsCookies.set(name, value, { path, secure });
  } else {
    if (!numberIsInteger(expires)) {
      throw new Error('Expires parameter needs to be an integer.');
    }
    jsCookies.set(name, value, { expires, path, secure });
  }
}

/**
 * Stores full cookie with absolute expiration date in the document
 * @param name Cookie name
 * @param value Cookie value
 * @param expirationDate Cookie expiration date
 * @param options object for optional parameters
 */
export function storeCookieByDate(
  name: string,
  value: string,
  expirationDate: Date,
  { path = '/', secure = true }: CookieOptions = {},
): void {
  if (
    !expirationDate ||
    typeof expirationDate !== 'object' ||
    !expirationDate.toUTCString
  ) {
    throw new Error('Expiration date must be a Date.');
  }
  jsCookies.set(name, value, { expires: expirationDate, path, secure });
}
